module.exports = __webpack_public_path__ + "static/record-verify-approve-shift-timesheets-3d8bd7c76a0a65da8406bb35a340cc1c.png";